import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const AssignOps = () => {

    const [centerList, setCenterList] = useState<any[]>([]);
    const [opsList, setOpsList] = useState<any[]>([]);
    const [centerOpsList, setCenterOpsList] = useState<any[]>([]);
    const [centerId, setCenterId] = useState("");
    const [opsId, setOpsId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchCenterList();
    }, [])

    async function fetchCenterList() {
        setIsLoading(true);
        const centerResponse = await func.centerOps(null);
        setCenterOpsList(Array.isArray(centerResponse) ? centerResponse : [])
        setIsLoading(false);
    }

    const filteredData = centerOpsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const centerNameRender = (rowData) => {
        return <span>{rowData.geoCenterName}</span>;
    };

    const opsNameRender = (rowData) => {
        return <span>{rowData.opsName}</span>;
    };

    async function newOps() {
        setIsEdit(false)
        setOpenModal(true)
        setCenterId('')
        setOpsId('')
        const stateResponse = await func.listGeoCenters();
        setCenterList(Array.isArray(stateResponse) ? stateResponse : [])
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCenter();
            } else {
                const formData = new FormData();
                // formData.append("geographyId", stateId);
                // formData.append("districtId", districtId);
                formData.append("centerId", centerId);
                formData.append("opsUserId", opsId);

                const assign = api.AssignOpsToCenter;
                fetch(assign, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchCenterList();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Assign Ops to Center</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newOps() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Assign Ops to Center">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="geoCenterName"
                                                header="Center Name"
                                                body={centerNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="opsName"
                                                header="Ops Name"
                                                body={opsNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="sm">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Assign "} Ops to Center</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Center</label>
                                <Select
                                    value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                        value: centerId,
                                        label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                    } : null}
                                    onChange={async (e) => {
                                        setCenterId(e.value);
                                        const usrResponse = await func.listUsers();
                                        setOpsList(Array.isArray(usrResponse) ? usrResponse : [])
                                    }}
                                    required
                                    placeholder="Select Center"
                                    options={centerList.map(cntr => ({
                                        value: cntr.geoCenterId,
                                        label: cntr.geoCenterName
                                    }))}>
                                </Select>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Ops</label>
                                <Select
                                    value={opsList.find(ops => ops.userId === opsId) ? {
                                        value: opsId,
                                        label: opsList.find(ops => ops.userId === opsId).userFirstName + " " +
                                            opsList.find(ops => ops.userId === opsId).userLastName
                                    } : null}
                                    onChange={async (e) => {
                                        setOpsId(e.value);
                                    }}
                                    required
                                    placeholder="Select Ops"
                                    options={opsList.map(ops => ({
                                        value: ops.userId,
                                        label: ops.userFirstName + " " + ops.userLastName
                                    }))}>
                                </Select>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    )
};

export default AssignOps;